<template>
  <confirmation-dialog
    value="true"
    :onConfirmed="onConfirmed"
    :onCancelled="onCancelled">
    <h3>{{ $t('site-administration.instant-charge.confirmation.header') }}</h3>
    <p>{{ $t('site-administration.instant-charge.confirmation.paragraph-1') }}</p>
    <p>{{ $t('site-administration.instant-charge.confirmation.paragraph-2') }}</p>
  </confirmation-dialog>
</template>

<script>
import ConfirmationDialog from '../confirmation-dialog'
export default {
  components: {
    ConfirmationDialog
  },
  props: {
    onConfirmed: { type: Function, required: true },
    onCancelled: { type: Function, required: true }
  }
}
</script>
